import React, { useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import '../styles/AboutPage.css';
import aboutImg from "../assets/images/aboutusimg.PNG";
import Preloader from "../components/Preloader";
import MissionImg from "../assets/images/mission.png"
import VisionImg from "../assets/images/vision.png"
import { FaHandsBound } from 'react-icons/fa6';
import { FaImages } from 'react-icons/fa';

const StatCounter = ({ end, title, suffix = "" }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });

  return (
    <div className="col-md-4 mb-4" ref={ref}>
      <div className="stat-card">
        <h2 className="display-4 fw-bold text-orange">
          {inView ? <CountUp end={end} duration={2.5} suffix={suffix} /> : '0'}
        </h2>
        <p className="text-muted fw-semibold">{title}</p>
      </div>
    </div>
  );
};

const AboutPage = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Preloader />;

  return (
    <div className="about-page-wrapper">
      
      {/* --- Header Section --- */}
      <section className="about-header text-center py-5 bg-navy text-white">
          <div className="container " style={{marginTop:"60px"}}>
                  <div className="d-inline-flex align-items-center gap-3 mb-3">
                    <div>
                      <h1 className="h2 fw-bold">
                         <span className="p-2 rounded-lg infra-icon-box me-2">
                      <FaHandsBound />
                    </span>
                        About <span className="highlight">Us</span>
                      </h1>
                      <p className="text-light sub-tittle mb-0">
                        Quality, Innovation & Excellence in Paper Board Manufacturing
                      </p>
                    </div>
                  </div>
                </div>
      </section>

      {/* --- Main Content Section --- */}
      <section className="py-5">
        <div className="container">
          <div className="row align-items-center g-5">
            
            {/* Image with Smooth Effects */}
            <div className="col-lg-5">
              <div className="about-image-container">
                <div className="image-wrapper">
                  <img 
                    src={aboutImg} 
                    alt="Sri Krishna Hi-Tech Paper Board Manufacturing" 
                    className="img-fluid rounded floating-image" 
                  />
                  <div className="image-overlay"></div>
                </div>
                <div className="experience-badge floating-badge">
                  <span className="years">9+</span>
                  <span className="text">Years of Experience</span>
                </div>
              </div>
            </div>

            {/* Company Overview */}
            <div className="col-lg-7">
              <div className="company-highlight-box p-4 mb-3">
                <h3 className="fw-bold mb-4 text-navy border-bottom pb-3">
                  Sri Krishna Hi-Tech Paper Board
                </h3>
                <div className="row g-3">
                  <div className="col-sm-6">
                    <div className="info-item">
                      <strong className="text-navy">Established:</strong>
                      <span>2017</span>
                    </div>
                    <div className="info-item">
                      <strong className="text-navy">Nature of Business:</strong>
                      <span>Manufacturer</span>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="info-item">
                      <strong className="text-navy ">CEO:</strong>
                      <div className='ceo'>
                      <span>Mr. S. N. Jeyachandran</span>
                      {/* <span className='sub-info'>(25 Yrs - Exp)</span> */}
                      </div>
                    </div>
                    <div className="info-item">
                      <strong className="text-navy">Total Employees:</strong>
                      <span>80 – 100 People</span>
                    </div>
                  </div>
                </div>
              </div>

              
            </div>

          </div>
        </div>

        <div className='container mt-4'>
          <h6 className="text-orange fw-bold text-uppercase mb-3">Company Overview</h6>
              <p className="overview mb-4">
                Sri Krishna Hi-Tech Paper Board is a professionally managed manufacturing company 
                established in the year 2017, specializing in high-quality paper board and innovative 
                packaging solutions. With a strong focus on quality, durability, and customer satisfaction, 
                the company has steadily built a reputation as a reliable manufacturer serving diverse industries.
              </p>
              <p className="overview">
                Backed by modern manufacturing practices and skilled manpower, Sri Krishna Hi-Tech Paper Board 
                delivers products that meet both functional and aesthetic requirements across commercial and 
                industrial applications.
              </p>
        </div>
      </section>

      {/* --- Stats Section --- */}
      {/* <section className="bg-light py-5 text-center">
        <div className="container">
          <div className="row">
            <StatCounter end={50} title="Skilled Professionals" suffix="+" />
            <StatCounter end={25} title="Annual Turnover (Crores)" suffix="Cr+" />
            <StatCounter end={9} title="Years in Industry" suffix="+" />
          </div>
        </div>
      </section> */}

      {/* --- Stats Section - Redesigned --- */}
<section className="stats-section py-5">
  <div className="container">
    <div className="row g-4 justify-content-center">
      
      {/* Stat 1 - Skilled Professionals */}
      <div className="col-lg-4 col-md-6">
        <div className="stat-card-new">
          <div className="stat-icon-wrapper">
            <i className="bi bi-people-fill stat-icon"></i>
            {/* Alternatively, you can use a PNG:
            <img src="/path/to/professionals-icon.png" alt="Professionals" className="stat-png-icon" />
            */}
          </div>
          <div className="stat-content">
            <div className="stat-number">
              <CountUp 
                end={50} 
                duration={3} 
                suffix="+" 
                className="stat-counter"
              />
            </div>
            <h4 className="stat-title">Skilled Professionals</h4>
            {/* <p className="stat-description">
              Our dedicated team brings expertise and innovation to every project
            </p> */}
          </div>
          <div className="stat-ribbon">
            <span>TEAM</span>
          </div>
        </div>
      </div>

      {/* Stat 2 - Annual Turnover */}
      <div className="col-lg-4 col-md-6">
        <div className="stat-card-new">
          <div className="stat-icon-wrapper">
            <i className="bi bi-graph-up-arrow stat-icon"></i>
            {/* Alternatively, you can use a PNG:
            <img src="/path/to/turnover-icon.png" alt="Turnover" className="stat-png-icon" />
            */}
          </div>
          <div className="stat-content">
            <div className="stat-number">
              <CountUp 
                end={25} 
                duration={3} 
                suffix="Cr+" 
                className="stat-counter"
              />
            </div>
            <h4 className="stat-title">Annual Turnover</h4>
            {/* <p className="stat-description">
              Consistent growth and financial stability in the paper industry
            </p> */}
          </div>
          <div className="stat-ribbon">
            <span>GROWTH</span>
          </div>
        </div>
      </div>

      {/* Stat 3 - Years in Industry */}
      <div className="col-lg-4 col-md-6">
        <div className="stat-card-new">
          <div className="stat-icon-wrapper">
            <i className="bi bi-award-fill stat-icon"></i>
            {/* Alternatively, you can use a PNG:
            <img src="/path/to/experience-icon.png" alt="Experience" className="stat-png-icon" />
            */}
          </div>
          <div className="stat-content">
            <div className="stat-number">
              <CountUp 
                end={9} 
                duration={3} 
                suffix="+" 
                className="stat-counter"
              />
            </div>
            <h4 className="stat-title">Years in Industry</h4>
            {/* <p className="stat-description">
              Decades of experience delivering excellence in paper manufacturing
            </p> */}
          </div>
          <div className="stat-ribbon">
            <span>EXPERIENCE</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* --- Product Portfolio Section --- */}
      <section className="py-2">
        <div className="container">
          <div className="section-header text-center mb-5">
            <h2 className="fw-bold text-navy">Our Product Portfolio</h2>
            <p className="text-muted">Premium Quality Kappa Board & Packaging Solutions</p>
          </div>
          
          <div className="row g-4">
            {[
              { category: "Kappa Boards", items: ["Kappa Board", "Hi-Tech Board", "Maplitho Paper (A Grade)"] },
              { category: "Packaging Boxes", items: ["Kappa Paper Board Boxes", "Jewellery Boxes", "Rigid Boxes", "Sweet Boxes"] },
              { category: "Specialty Products", items: ["PE Coated Products", "Bakery Packaging Items", "Oil Content Packaging Solutions"] },
              { category: "Stationery", items: ["Notebooks", "Diaries", "Office Stationery"] }
            ].map((group, idx) => (
              <div className="col-lg-3 col-md-6" key={idx}>
                <div className="product-category-card h-100">
                  <h5 className="about-title text-navy">{group.category}</h5>
                  <ul className="list-unstyled">
                    {group.items.map((item, i) => (
                      <li key={i} className="product-item">
                        <i className="bi bi-check-circle text-orange me-2"></i>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* --- Strengths & Industries Section --- */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-6">
              <div className="strengths-card p-4 h-100">
                <h4 className="fw-bold text-navy mb-4">
                  <i className="bi bi-gear-wide-connected text-orange me-2"></i>
                  Manufacturing Strengths
                </h4>
                <ul className="list-unstyled">
                  {[
                    "Advanced manufacturing facilities",
                    "Strict quality control standards",
                    "Customization as per client requirements",
                    "Timely production and delivery",
                    "Environment-friendly and sustainable practices"
                  ].map((strength, idx) => (
                    <li key={idx} className="mb-3">
                      <div className="strength-item">
                        <div className="strength-icon">
                          <i className="bi bi-check-lg"></i>
                        </div>
                        <span>{strength}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="industries-card p-4 h-100">
                <h4 className="fw-bold text-navy mb-4">
                  <i className="bi bi-building text-orange me-2"></i>
                  Industries We Serve
                </h4>
                <div className="industries-grid">
                  {[
                    "Food & Bakery", "Confectionery & Sweets", "Jewellery", "Diaries & Notebooks" ,"Calendar", 
                    "Stationery & Publishing", "Gift, Mobile & Rigit BOX ", "Industrial Packaging"
                  ].map((industry, idx) => (
                    <div key={idx} className="industry-tag">
                      {industry}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- Vision & Mission Section --- */}
      <section className="py-2 mb-5">
        <div className="container">
          <div className="row g-4">
            <div className="col-md-6">
              <div className="vision-card p-4 h-100">
                <h4 className="fw-bold text-navy">
                  <img src={VisionImg} alt="Vision" className="vision-img me-2" />
                  Our Vision
                  </h4>
                <p className="text-muted">
                  To become a trusted leader in the Kappa board and packaging industry by consistently 
                  delivering superior-quality products and innovative solutions while maintaining 
                  sustainable manufacturing practices.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="mission-card p-4 h-100">
                <h4 className="fw-bold text-navy">
                  <img src={MissionImg} alt="mission" className="mission-img me-2" />
                  Our Mission
                </h4>
                <ul className="list-unstyled"> 
                  {[
                    "Provide high-quality and cost-effective packaging solutions",
                    "Ensure customer satisfaction through reliability and service excellence",
                    "Continuously upgrade technology and skills",
                    "Build long-term relationships with customers and partners"
                  ].map((mission, idx) => (
                    <li key={idx} className="mb-2">
                      <i className="bi bi-check-circle-fill text-orange me-2"></i>
                      {mission}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- Why Choose Us Section --- */}
      <section className="py-5 bg-navy text-white">
        <div className="container">
          <div className="section-header text-center mb-5">
            <h2 className="fw-bold">Why Choose Us</h2>
            <p className="opacity-75">Excellence in Every Product We Deliver</p>
          </div>
          
          <div className="row g-4">
            {[
              { icon: "bi-people", title: "Experienced Leadership", desc: "Skilled workforce with industry expertise" },
              { icon: "bi-clipboard-check", title: "Quality Tested", desc: "Wide range of certified products" },
              { icon: "bi-cash-coin", title: "Competitive Pricing", desc: "Best value for your investment" },
              { icon: "bi-lightbulb", title: "Innovation Focus", desc: "Commitment to continuous improvement" },
              { icon: "bi-person-heart", title: "Customer-Centric", desc: "Strong focus on client satisfaction" },
              { icon: "bi-award", title: "Trust & Reliability", desc: "Proven track record of excellence" }
            ].map((item, idx) => (
              <div className="col-lg-4 col-md-6" key={idx}>
                <div className="why-choose-card p-4 h-100">
                  <div className="why-icon mb-3">
                    <i className={`bi ${item.icon}`}></i>
                  </div>
                  <h5 className="fw-bold mb-3">{item.title}</h5>
                  <p className="opacity-75 mb-0">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-5 pt-4">
            <div className="final-statement p-4 rounded bg-white text-navy">
              <h4 className="fw-bold mb-3">
                Sri Krishna Hi-Tech Kappa Board
              </h4>
              <p className="mb-0">
                stands as a symbol of quality, trust, and innovation in Kappa board 
                manufacturing and packaging solutions.
              </p>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default AboutPage;